import moment from "moment/moment"
import { Palette } from "@mui/material/styles/createPalette"
import { faClock, faPartyHorn, faCircleExclamation, faCheckCircle } from "@fortawesome/pro-solid-svg-icons"

interface ExaminationText {
  hasExpired: boolean
  hasPassed: boolean
  date: Date | undefined
  isExpiresIn30Days: boolean
  recertificationPeriod: boolean
}

export const getColors = (status: string, theme: { palette: Palette }) => {
  const style: {
    textColor: string | undefined
    bgColor: string | undefined
  } = {
    textColor: `${status}.dark`,
    bgColor: `${status}.light`
  }
  if (status === "warning") {
    style.textColor = theme.palette.warning[500]
  } else if (status === "background") {
    style.textColor = theme.palette.grey[800]
    style.bgColor = `${status}.default`
  }
  return style
}

export const getExaminationText = (examinationStatusObject: ExaminationText, t: any) => {
  if (examinationStatusObject.hasExpired) {
    return t("learning.titles.expired", "Expired")
  } else if (examinationStatusObject.hasPassed) {
    return t("learning.titles.passed", "Passed")
  } else if (
    examinationStatusObject?.date &&
    moment(examinationStatusObject.date).diff(moment(), "days") > 30
  ) {
    const daysCount = moment(examinationStatusObject.date).diff(moment(), "days")
    return `${t("learning.titles.due_in", "Due in")} ${daysCount} ${t("global.days", "days")}`
  } else if (examinationStatusObject.isExpiresIn30Days) {
    const daysCount = moment(examinationStatusObject.date).diff(moment(), "days")
    return `${t("learning.titles.due_within", "Due within")} ${daysCount} ${t("global.days", "days")}`
  }
}
export const getExaminationColor = (examinationStatusObject: ExaminationText) => {
  if (examinationStatusObject.hasExpired) {
    return "error"
  } else if (examinationStatusObject.hasPassed) {
    return "success"
  } else if (
    examinationStatusObject?.date &&
    moment(examinationStatusObject.date).diff(moment(), "days") > 30
  ) {
    return "background"
  } else if (examinationStatusObject.isExpiresIn30Days) {
    return "warning"
  }
}
export const getExaminationIcon = (examinationStatusObject: ExaminationText) => {
  if (examinationStatusObject.hasExpired) {
    return faCircleExclamation
  } else if (examinationStatusObject.hasPassed) {
    return faCheckCircle
  } else if (
    examinationStatusObject?.date &&
    moment(examinationStatusObject.date).diff(moment(), "days") > 30
  ) {
    return faClock
  } else if (examinationStatusObject.isExpiresIn30Days) {
    return faClock
  }
}
